import { Slash } from "react-feather"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { readIpRestrictedMessage } from "@/features/ip-restriction"

export function IpRestrictedPage() {
  const navigate = useNavigate()
  const message = readIpRestrictedMessage()

  const handleGoToLogin = () => {
    navigate("/login")
  }

  return (
    <div className="bg-white shadow rounded-lg p-8 w-full text-center">
      <div className="flex justify-center mb-6">
        <div className="bg-red-100 rounded-full p-4">
          <Slash size={48} className="text-red-600" />
        </div>
      </div>

      <h1 className="text-2xl font-bold text-gray-900 mb-2">アクセスが制限されています</h1>

      <p className="text-gray-500 mb-4">
        所属する組織では、許可された IP アドレスからのみ管理画面を利用できます。
        <br />
        社内ネットワークや VPN
        に接続しているか確認し、解決しない場合は組織の管理者にお問い合わせください。
      </p>

      {message && (
        <p className="text-sm text-gray-700 bg-gray-50 rounded p-3 mb-6 break-all">{message}</p>
      )}

      <Button onClick={handleGoToLogin}>ログイン画面へ</Button>
    </div>
  )
}
